import { FuseNavigation } from "@fuse/types";

export const navigation: FuseNavigation[] = [
  {
    id: "general",
    title: "App",
    translate: "NAV.APPLICATIONS",
    type: "group",
    children: [
      {
        id: "dashboard",
        title: "Dashboard",
        translate: "NAV.DASHBOARD",
        type: "item",
        icon: "dashboard",
        image: "dashboard1.png",
        url: "dashboard",
      },
      {
        id: "planning",
        title: "Planning",
        // translate: "NAV.DASHBOARD",
        type: "item",
        icon: "dashboard",
        image: "planning-macro-planning.png",
        url: "planning",
      },

      {
        id: "contracts",
        title: "Contract",
        image: "order.png",
        type: "collapsable",
        permission: "PERMISSION_CONTRACT_VIEW",
        children: [
          {
            id: "upcoming-contracts",
            title: "Upcoming Contract",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "upcoming-contracts",
          },
          {
            id: "planned-contracts",
            title: "Planned Contract",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "planned-contracts",
          },
          {
            id: "inexecution-contracts",
            title: "Inexecution Contract",
            type: "item",
            icon: "dashboard",
            image: "in execution contract.png",
            url: "inexecution-contracts",
          },
          {
            id: "closed-contracts",
            title: "Closed Contract",
            type: "item",
            icon: "dashboard",
            image: "in execution contract.png",
            url: "closed-contracts",
          },

        ]
      },
      {
        id: "budgets-for-approval",
        title: "Budgets For Approval",
        translate: "NAV.DASHBOARD",
        type: "item",
        icon: "dashboard",
        image: "dashboard.png",
        url: "budgets-for-approval",
        permission: "PERMISSION_BUDGET_APPROVAL_VIEW",
      },
      {
        id: "procurement-budgets-for-approval",
        title: "Procurement Budgets For Approval",
        translate: "NAV.DASHBOARD",
        type: "item",
        icon: "dashboard",
        image: "dashboard.png",
        url: "procurement-budgets-for-approval",
        permission: "PERMISSION_BUDGET_APPROVAL_VIEW",
      },
      {
        id: "delivery-lot",
        title: "Delivery Lots",
        translate: "NAV.DASHBOARD",
        type: "item",
        icon: "dashboard",
        image: "dashboard.png",
        url: "delivery-lots",
        permission: "PERMISSION_CONTRACT_LOT_VIEW",
      },
      {
        id: "psi",
        title: "PSI",
        translate: "NAV.DASHBOARD",
        type: "item",
        icon: "dashboard",
        image: "dashboard.png",
        url: "psis",
        permission: "PERMISSION_PSI_VIEW",
      },
      {
        id: "delivery",
        title: "Delivery",
        translate: "NAV.DASHBOARD",
        type: "item",
        icon: "dashboard",
        image: "delivery.png",
        url: "delivery",
        permission: "PERMISSION_DELIVERY_VIEW"
      },

      {
        id: "pli",
        title: "PLI",
        translate: "NAV.DASHBOARD",
        type: "item",
        icon: "dashboard",
        image: "dashboard.png",
        url: "pli",
        permission: "PERMISSION_PLI_VIEW"
      },
      {
        id: "invoices",
        title: "Invoice",
        translate: "NAV.DASHBOARD",
        type: "item",
        icon: "dashboard",
        image: "invoice.png",
        url: "invoices",
        permission: "PERMISSION_INVOICE_VIEW"
      },
      {
        id: "payments",
        title: "Payments",
        translate: "NAV.DASHBOARD",
        type: "item",
        icon: "dashboard",
        image: "payment.png",
        url: "payments",
        permission: "PERMISSION_INVOICE_PAYMENT_VIEW"
      },
      {
        id: "direct-sales",
        title: "Direct Sale",
        image: "direct sales.png",
        type: "collapsable",
        permission: "PERMISSION_DIRECT_SALE_VIEW",
        children: [
          {
            id: "Direct Sale order",
            title: "Order",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "direct-sales",
          },
          {
            id: "direct-sale-varification",
            title: "Varify",
            translate: "Varify",
            type: "item",
            icon: "varify",
            image: "dashboard.png",
            url: "direct-sale-varification",
          },
          {
            id: "direct-sale-delivery",
            title: "Delivery",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "direct-sale-delivery",
          },
          {
            id: "direct-sale-payments",
            title: "Payment",
            translate: "Payment",
            type: "item",
            icon: "Payment",
            image: "dashboard.png",
            url: "direct-sale-payments",
          },
          {
            id: "direct-sale-init-order",
            title: "Old Order",
            translate: "Old Order",
            type: "item",
            icon: "Payment",
            image: "dashboard.png",
            url: "direct-sale-init-order",
          },

          {
            id: "direct-sale-report",
            title: "Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "direct-sale-report",
          },
          {
            id: "email-notifications",
            title: "Email Notifications",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "email-notifications",
          },

        ]


      },
      {
        id: "reports",
        title: "Report",
        image: "order.png",
        type: "collapsable",
        children: [
          {
            id: "plan-target-report",
            title: "Plan Target",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "plan-target-report",
            permission: "PERMISSION_REPORT_PLAN_TARGET_VIEW"
          },
          {
            id: "credit-summary-report",
            title: "Credit Summary",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "credit-summary-report",
            permission: "PERMISSION_REPORT_CREDIT_SUMMARY_VIEW"
          },
          {
            id: "credit-details-report",
            title: "Credit Details",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "credit-details-report",
            permission: "PERMISSION_REPORT_CREDIT_DETAIL_VIEW"
          },
          {
            id: "cost-budget-cumulative-report",
            title: "Cumulative Cost Budget",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "cost-budget-cumulative-report",
            permission: "PERMISSION_REPORT_CUMULATIVE_COST_BUDGET_VIEW"
          },
          {
            id: "lot-wise-cost-budget-report",
            title: "Lot Wise Cost Budget",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "lot-wise-cost-budget-report",
            permission: "PERMISSION_REPORT_CUMULATIVE_COST_BUDGET_VIEW"
          },
          {
            id: "gross-profit-selling-price-report",
            title: "Gross Profit & Selling",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "gross-profit-selling-price-report",
            permission: "PERMISSION_REPORT_GROSS_PROFIT_VIEW"
          },
          {
            id: "budgetary-costing-valuation-report",
            title: "Budgetary Costing Valuation",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "budgetary-costing-valuation-report",
            permission: "PERMISSION_BUDGETARY_COSTING_VALUATION_VIEW"
          },
          {
            id: "budgetary-costing-valuation-details-report",
            title: "Budgetary Costing Valuation Details",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "budgetary-costing-valuation-details-report",
            permission: "PERMISSION_BUDGETARY_COSTING_VALUATION_DETAIL_VIEW"
          },
          {
            id: "forecasted-actual-consumed-report",
            title: "Forecasted vs Actual Consumed",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "forecasted-actual-consumed-report",
          },
          {
            id: "payment-assumptions",
            title: "Payment Assumptions",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "payment-assumptions",
            permission: "PERMISSION_PAYMENT_ASSUMPTION_VIEW"
          },
          {
            id: "collection-report",
            title: "Collections",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "collection-report",
          },
          {
            id: "delivery-collection-report",
            title: "Delivery & Collections",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "delivery-collection-report",
          },
          {
            id: "contracts-report",
            title: "Contracts",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "contracts-report",
          },
          {
            id: "contracts-working-capital-report",
            title: "Contracts Working Capital",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "contracts-working-capital-report",
          },
          {
            id: "working-capital-management-report",
            title: "Working Capital Management Dashboard",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "working-capital-management-report",
          },
          {
            id: "contract-product-report",
            title: "Contract Products",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "contract-product-report",
          },
          {
            id: "pnl-status-report",
            title: "PNL Status",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "pnl-status-report",
          },
          {
            id: "collection-summary-report",
            title: "Collection Summary Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "collection-summary-report",
          },


        ]
      },
      {
        id: "forecast-reports",
        title: "Forecast Report",
        image: "order.png",
        type: "collapsable",
        children: [
          {
            id: "occupancy-capacity-report",
            title: "Occupancy vs Capacity Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "occupancy-capacity-report",
          },
          {
            id: "quarterly-revenue-report",
            title: "Quarterly Revenue Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "quarterly-revenue-report",
          },
          {
            id: "contract-status-report",
            title: "Contract Status Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "contract-status-report",
          },
          {
            id: "contract-acquisition-report",
            title: "Monthly Acquisition Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "contract-acquisition-report",
          },
          {
            id: "executing-contract-report",
            title: "Executing Contract Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "executing-contract-report",
          },

          {
            id: "variance-report",
            title: "Variance Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "variance-report",
          },
        ]
      },
      {
        id: "dso-reports",
        title: "DSO Report",
        image: "order.png",
        type: "collapsable",
        children: [
          {
            id: "dso-unit-report",
            title: "DSO Unit Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "dso-unit-report",
          },
          {
            id: "broad-category-report",
            title: "Broad Category Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "broad-category-report",
          },
          {
            id: "dso-product-category-report",
            title: "DSO Product Category Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "dso-product-category-report",
          },
          {
            id: "dso-client-report",
            title: "DSO Client Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "dso-client-report",
          },
          {
            id: "dso-execution-head-report",
            title: "DSO Execution Head Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "dso-execution-head-report",
          },
          {
            id: "dso-parent-contract-report",
            title: "DSO Parent Contract Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "dso-parent-contract-report",
          },
          {
            id: "dso-ba-team-report",
            title: "DSO BA Team Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "dso-ba-team-report",
          }

        ]
      },
      {
        id: "projects",
        title: "Projects",
        type: "item",
        icon: "settings",
        image: "dashboard.png",
        url: "projects",
        // permission: "PERMISSION_MENU_SETTINGS",
      },
      {
        id: "projects-for-approval",
        title: "Approve Projects",
        type: "item",
        icon: "settings",
        image: "dashboard.png",
        url: "projects-for-approval",
        permission: "PERMISSION_PROJECT_BUDGET_MENU_VIEW",
      },
      {
        id: "duty-drawback",
        title: "Duty Drawback",
        type: "item",
        icon: "settings",
        image: "dashboard.png",
        url: "duty-drawback",
        // permission: "PERMISSION_MENU_SETTINGS",
      },
      {
        id: "duty-drawback-payments",
        title: "Duty Drawback Payments",
        type: "item",
        icon: "settings",
        image: "dashboard.png",
        url: "duty-drawback-payments",
        // permission: "PERMISSION_MENU_SETTINGS",
      },
      {
        id: "site-expenses-and-other-consumables",
        title: "Site Expenses and other Consumables",
        type: "item",
        icon: "settings",
        image: "dashboard.png",
        url: "site-expenses-and-other-consumables",
        permission: "PERMISSION_PROMOTIONAl_EXPENSE_VIEW",
      },

      {
        id: "treasury",
        title: "Treasury",
        image: "direct sales.png",
        type: "collapsable",
        children: [
          {
            id: "loan-list",
            title: "Loan List",
            type: "item",
            icon: "settings",
            image: "dashboard.png",
            url: "loan-list",
          },
          {
            id: "loan-payment",
            title: " Payment List",
            type: "item",
            icon: "settings",
            image: "dashboard.png",
            url: "loan-payment",
          },
          {
            id: "loan-payment-report",
            title: "Loan Payment Report",
            type: "item",
            icon: "settings",
            image: "dashboard.png",
            url: "loan-payment-report",
            permission: "PERMISSION_LOAN_MODULE_VIEW",
          },
          {
            id: "dashboard-outstanding-report",
            title: "Dashboard Outstanding",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "dashboard-outstanding-report",
          },
          {
            id: "bank-wise-loan-report",
            title: "Bank Wise Loan Report",
            type: "item",
            icon: "dashboard",
            image: "dashboard.png",
            url: "bank-wise-loan-report",
          },
          // Added collapsable "Treasury settings" with three sub-menus
          {
            id: "treasury-settings",
            title: "Treasury settings",
            type: "collapsable",
            icon: "settings",
            image: "dashboard.png",
            children: [
              {
                id: "treasury-project",
                title: "Treasury Project",
                type: "item",
                icon: "settings",
                image: "dashboard.png",
                url: "treasury-project",
              },
              {
                id: "types-of-loan",
                title: "Types of Loan",
                type: "item",
                icon: "dashboard",
                image: "dashboard.png",
                url: "options/types-of-loan",
              },
              {
                id: "type-of-loan",
                title: "Categories of Loan",
                type: "item",
                icon: "dashboard",
                image: "dashboard.png",
                url: "options/loan-categories",
              },
              {
                id: "company",
                title: "Company",
                type: "item",
                icon: "dashboard",
                image: "dashboard.png",
                url: "options/loan-company",
              },
              {
                id: "loan-currency",
                title: "Loan Currency",
                type: "item",
                icon: "dashboard",
                image: "dashboard.png",
                url: "loan-currency",
              }

            ]
          },

        ]


      },
      {
        id: "user-manuals",
        title: "User Manual Setup",
        type: "item",
        icon: "dashboard",
        image: "production-requisition.png",
        permission: "PERMISSION_USER_MANUAL_VIEW",
        url: "/user-manuals",
      },
      {
        id: "options",
        title: "Settings",
        type: "item",
        icon: "settings",
        image: "dashboard.png",
        url: "options",
        // permission: "PERMISSION_MENU_SETTINGS",
      },


    ]
  },

];
